import { createSlice } from '@reduxjs/toolkit'
import { FormValuesAdvance } from '../../../types/advance'

const advanceSlice = createSlice({
  name: 'advance',
  initialState: {
    isEdit: false,
    dataSave: {} as FormValuesAdvance
  },
  reducers: {
    setEdit: (state, action) => {
      state.isEdit = action.payload
    },
    setDataSave: (state, action) => {
      state.dataSave = action.payload
    }
  }
})

export const { setEdit, setDataSave } = advanceSlice.actions

export default advanceSlice.reducer
